import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ServiceManagerBase } from '../common/service-manager-base';
import { BroadcastService } from '../../core/services/broadcast.service';

import { ImageManagerService } from '../images/image-manager.service';
import { Folder } from './folder.model';
import { FolderApiService } from './folder-api.service';

@Injectable({
    providedIn: 'root'
})
export class FolderManagerService extends ServiceManagerBase
{
    constructor(private folderApiService: FolderApiService,
                protected broadcastService: BroadcastService,
                private imageManager: ImageManagerService)
    {
        super(broadcastService);
    }

    clearCache()
    {
    }

    // Note: parentAlbumId = 0 for top-level
    getFolder(id: number): Observable<Folder>
    {
        return this.folderApiService.getFolder(id);
    }
}
